<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_gift" transform="translate(-627 -469)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(627 469)"
      />
      <g id="그룹_8628" data-name="그룹 8628" transform="translate(80 -43.165)">
        <rect
          id="사각형_6068"
          data-name="사각형 6068"
          fill="#ffc304"
          width="20"
          height="16"
          rx="2"
          transform="translate(549 519)"
        />
        <rect
          id="사각형_6070"
          data-name="사각형 6070"
          fill="#087ef7"
          width="20"
          height="3"
          transform="translate(549 529)"
        />
        <g id="그룹_8630" data-name="그룹 8630" transform="translate(0.471)">
          <g
            id="그룹_8628-2"
            data-name="그룹 8628"
            transform="matrix(0.819, 0.574, -0.574, 0.819, 398.239, -226.541)"
          >
            <path
              id="제외_1"
              data-name="제외 1"
              fill="#087ef7"
              d="M4183-160a3,3,0,0,1-3-3,3,3,0,0,1,3-3,3,3,0,0,1,3,3A3,3,0,0,1,4183-160Zm0-4a1,1,0,0,0-1,1,1,1,0,0,0,1,1,1,1,0,0,0,1-1A1,1,0,0,0,4183-164Z"
              transform="translate(-3627 682)"
            />
            <rect
              id="사각형_6069"
              data-name="사각형 6069"
              fill="#087ef7"
              width="2"
              height="7"
              transform="translate(557 519)"
            />
          </g>
          <g
            id="그룹_8629"
            data-name="그룹 8629"
            transform="matrix(-0.819, 0.574, -0.574, -0.819, 567.179, 521.521)"
          >
            <path
              id="제외_1-2"
              data-name="제외 1"
              fill="#087ef7"
              d="M3,0A3,3,0,1,0,6,3,3,3,0,0,0,3,0ZM3,4A1,1,0,1,1,4,3,1,1,0,0,1,3,4Z"
              transform="translate(0 3.999)"
            />
            <rect
              id="사각형_6069-2"
              data-name="사각형 6069"
              fill="#087ef7"
              width="2"
              height="7"
              transform="translate(4 0)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
